export const navItems = [
  { id: "service", label: "수리서비스" },
  { id: "items", label: "수리항목" },
  { id: "cases", label: "수리사례" },
  { id: "process", label: "수리과정" },
  { id: "price", label: "수리비용" },
  { id: "reviews", label: "고객후기" },
  { id: "faq", label: "FAQ" },
  { id: "location", label: "오시는 길" },
  { id: "inquiry", label: "온라인 문의" },
];

export const contactInfo = {
  phone: "1600-2040",
  phoneHref: "tel:1600-2040",
  kakaoHref: "https://pf.kakao.com/_macfix",
  email: "help@macfix.co.kr",
  address: "서울특별시 강남구 테헤란로 152, 8층 (강남역 2번 출구)",
  hours: "평일 09:30 - 19:00 · 토요일 10:00 - 16:00 · 일요일 휴무",
};

export const locationInfo = {
  mapEmbedSrc: "https://maps.google.com/maps?q=37.5006,127.0365&z=16&output=embed",
  directionsHref: "https://www.google.com/maps/dir/?api=1&destination=37.5006,127.0365",
  transit: [
    { icon: "ri-subway-line", title: "지하철", desc: "2호선·신분당선 강남역 2번 출구 도보 3분" },
    { icon: "ri-bus-2-line", title: "버스", desc: "강남역 정류장 하차 후 도보 3분 (간선·지선 다수)" },
  ],
  parking: [
    { icon: "ri-parking-box-line", title: "주차 안내", desc: "건물 지하 2~4층 주차장 이용, 수리 접수 고객 2시간 무료" },
    { icon: "ri-building-2-line", title: "건물 안내", desc: "테헤란로 152 맥픽스타워 8층, 로비 엘리베이터 이용" },
  ],
};

export const serviceItems = [
  {
    id: "logic-board",
    icon: "ri-cpu-line",
    title: "메인보드 수리",
    desc: "미세 회로 단위까지 진단하여 침수·합선·전원 불량을 근본부터 복구합니다.",
    points: ["회로도 기반 정밀 진단", "BGA 리볼링", "전원부 단선 복구"],
  },
  {
    id: "screen",
    icon: "ri-macbook-line",
    title: "디스플레이 교체",
    desc: "정품급 패널로 백라이트 불량, 액정 크랙, 번인 현상을 정확하게 해결합니다.",
    points: ["액정 크랙 교체", "백라이트 재생", "스트라이프 불량 수리"],
  },
  {
    id: "battery",
    icon: "ri-battery-charge-line",
    title: "배터리 교체",
    desc: "순정 규격 배터리로 충전 불량, 급격한 방전, 부풀음 문제를 해결합니다.",
    points: ["배터리 사이클 초기화", "부풀음 안전 교체", "충전 회로 점검"],
  },
  {
    id: "keyboard",
    icon: "ri-keyboard-line",
    title: "키보드·트랙패드",
    desc: "버터플라이 키보드, 트랙패드 오작동을 정밀 분해 후 수리합니다.",
    points: ["키 입력 불량 복구", "트랙패드 클릭 복원", "백라이트 점검"],
  },
  {
    id: "water",
    icon: "ri-drop-line",
    title: "침수 복구",
    desc: "초음파 세척과 부식 제거로 침수된 로직보드를 살려냅니다.",
    points: ["초음파 정밀 세척", "부식 제거 및 코팅", "데이터 보존 우선"],
  },
  {
    id: "data",
    icon: "ri-hard-drive-2-line",
    title: "데이터 복구",
    desc: "부팅 불가 상태에서도 SSD와 저장장치 데이터를 최대한 복구합니다.",
    points: ["SSD 데이터 복구", "부팅 불가 데이터 추출", "이전·이관 서비스"],
  },
];

export const repairItems = [
  {
    id: "item-1",
    category: "전원",
    title: "전원이 전혀 켜지지 않아요",
    desc: "충전기를 연결해도 반응이 없다면 전원부 회로, 배터리 커넥터, 로직보드 손상 여부를 단계적으로 확인합니다. 대부분 전원 IC 또는 단선 문제로 수리 가능합니다.",
    symptoms: ["충전 표시등 미점등", "부팅 무반응", "완전 방전 반복"],
    time: "평균 1~2일",
  },
  {
    id: "item-2",
    category: "화면",
    title: "화면에 줄이 가거나 깨져요",
    desc: "디스플레이 케이블 접촉 불량, 패널 손상, GPU 발열로 인한 신호 불량을 구분하여 진단합니다. 케이블만 교체하면 되는 경우 비용을 대폭 절감할 수 있습니다.",
    symptoms: ["가로·세로 줄 발생", "화면 깜빡임", "일부 영역 검게 표시"],
    time: "당일 가능",
  },
  {
    id: "item-3",
    category: "발열",
    title: "팬 소리가 크고 발열이 심해요",
    desc: "서멀 그리스 경화와 먼지 축적으로 냉각 효율이 떨어지면 성능 저하와 발열이 발생합니다. 분해 청소 후 고성능 서멀 재도포로 온도를 낮춥니다.",
    symptoms: ["팬 소음 증가", "본체 과열", "성능 급격 저하"],
    time: "당일 가능",
  },
  {
    id: "item-4",
    category: "키보드",
    title: "키보드 일부 키가 안 눌려요",
    desc: "키캡 단위 문제인지, 키보드 시트 전체 문제인지 진단합니다. 개별 키 복원이 어려운 경우 키보드 모듈 전체를 교체하여 완벽하게 작동시킵니다.",
    symptoms: ["특정 키 미입력", "키 중복 입력", "키캡 들뜸"],
    time: "1~2일",
  },
  {
    id: "item-5",
    category: "액체",
    title: "음료를 쏟아서 침수됐어요",
    desc: "침수는 시간이 생명입니다. 전원을 끄고 즉시 방문하시면 부식을 최소화할 수 있습니다. 초음파 세척과 부식 제거로 로직보드를 살려냅니다.",
    symptoms: ["액체 접촉 후 꺼짐", "일부 기능 오작동", "부식 냄새"],
    time: "2~3일",
  },
  {
    id: "item-6",
    category: "성능",
    title: "속도가 갑자기 느려졌어요",
    desc: "SSD 노화, 열 스로틀링, 소프트웨어 문제를 구분해 진단합니다. 저장장치 교체와 냉각 정비로 초기 성능에 가깝게 되돌립니다.",
    symptoms: ["부팅 지연", "앱 실행 느림", "잦은 버벅임"],
    time: "당일 가능",
  },
];

export const processSteps = [
  {
    step: "01",
    icon: "ri-file-list-3-line",
    title: "온라인 접수",
    desc: "증상을 남겨주시면 담당 엔지니어가 확인 후 연락드립니다.",
  },
  {
    step: "02",
    icon: "ri-search-eye-line",
    title: "무료 정밀 진단",
    desc: "회로도 기반으로 문제 부위를 찾아 정확한 원인을 파악합니다.",
  },
  {
    step: "03",
    icon: "ri-price-tag-3-line",
    title: "비용·일정 안내",
    desc: "수리 항목과 예상 비용, 소요 시간을 투명하게 안내합니다.",
  },
  {
    step: "04",
    icon: "ri-tools-line",
    title: "정밀 수리 진행",
    desc: "동의 후 수리하며, 진행 상황을 실시간으로 공유합니다.",
  },
  {
    step: "05",
    icon: "ri-shield-check-line",
    title: "검수 및 출고",
    desc: "48시간 완충 테스트 후 무상 A/S 보증과 함께 인도합니다.",
  },
];

export const pricingItems = [
  {
    id: "p1",
    name: "메인보드 정밀 수리",
    price: "180,000",
    unit: "부터",
    desc: "전원 불량, 합선, 단선 복구",
    features: ["회로도 기반 진단", "BGA 리볼링 포함", "수리 후 6개월 보증"],
    highlight: true,
  },
  {
    id: "p2",
    name: "디스플레이 교체",
    price: "320,000",
    unit: "부터",
    desc: "정품급 패널 사용",
    features: ["모델별 패널 매칭", "당일 교체 가능", "품질 검수 후 인도"],
    highlight: false,
  },
  {
    id: "p3",
    name: "배터리 교체",
    price: "95,000",
    unit: "부터",
    desc: "순정 규격 배터리",
    features: ["사이클 초기화", "충전 회로 점검", "6개월 품질 보증"],
    highlight: false,
  },
  {
    id: "p4",
    name: "침수 복구",
    price: "150,000",
    unit: "부터",
    desc: "초음파 세척 + 부식 제거",
    features: ["데이터 보존 우선", "로직보드 정밀 세척", "재발 방지 코팅"],
    highlight: false,
  },
];

export const reviews = [
  {
    id: "r1",
    name: "김민수",
    model: "MacBook Pro 14 M2",
    rating: 5,
    text: "커피를 쏟아서 완전히 꺼졌는데 다른 곳에서 불가능하다던 수리를 여기서 살려냈습니다. 진단부터 설명까지 정말 꼼꼼했어요.",
  },
  {
    id: "r2",
    name: "이지은",
    model: "MacBook Air M1",
    rating: 5,
    text: "화면에 줄이 가서 갔는데 케이블 문제라 비용을 많이 아꼈어요. 과잉 수리 없이 정직하게 안내해 주셔서 신뢰가 갔습니다.",
  },
  {
    id: "r3",
    name: "박준호",
    model: "MacBook Pro 16 i9",
    rating: 5,
    text: "메인보드 전원 불량이었는데 회로 단위로 수리해 주셨습니다. 데이터도 그대로 살아 있어서 정말 감사했어요.",
  },
  {
    id: "r4",
    name: "최서연",
    model: "iMac 27 5K",
    rating: 5,
    text: "발열이 심해서 맡겼는데 청소와 서멀 재도포 후 팬 소음이 확 줄었습니다. 진행 상황을 사진으로 계속 알려주셔서 좋았어요.",
  },
  {
    id: "r5",
    name: "정우성",
    model: "MacBook Pro 13 2019",
    rating: 5,
    text: "키보드 먹통으로 방문했는데 당일 수리 받았습니다. 예상 시간을 정확히 지켜주셔서 일정 조율하기 편했어요.",
  },
];

export const faqs = [
  {
    id: "f1",
    q: "수리 진단 비용이 따로 있나요?",
    a: "방문 진단은 무료입니다. 다만 메인보드 정밀 진단처럼 분해와 장비가 필요한 경우에 한해 진단비가 발생하며, 수리를 진행하시면 진단비는 수리비에 포함됩니다. 진단 전 반드시 안내드립니다.",
  },
  {
    id: "f2",
    q: "수리 기간은 얼마나 걸리나요?",
    a: "단순 부품 교체는 당일 수리가 가능하며, 메인보드 수리나 침수 복구는 평균 1~3일 소요됩니다. 부품 수급이 필요한 경우 접수 시 정확한 일정을 안내드립니다.",
  },
  {
    id: "f3",
    q: "수리 후 데이터는 안전한가요?",
    a: "데이터 보존을 최우선으로 수리합니다. 부득이하게 데이터 손실 가능성이 있는 경우에는 수리 전 반드시 안내드리고 동의를 받은 후 진행합니다. 가능하면 사전 백업을 권장드립니다.",
  },
  {
    id: "f4",
    q: "A/S 보증 기간은 어떻게 되나요?",
    a: "수리 부위와 교체 부품에 따라 최소 3개월에서 최대 6개월의 무상 보증을 제공합니다. 보증 범위와 기간은 수리 완료 시 발급되는 수리 명세서에 명확히 기재됩니다.",
  },
  {
    id: "f5",
    q: "방문 수리와 택배 접수가 모두 가능한가요?",
    a: "네, 두 가지 모두 가능합니다. 매장 방문 시 당일 진단이 가능하고, 택배 접수는 온라인 문의로 신청하시면 수령부터 반송까지 안전하게 진행해 드립니다.",
  },
  {
    id: "f6",
    q: "정품이 아닌 부품을 사용하나요?",
    a: "상황에 따라 정품 또는 정품급 부품을 사용합니다. 반드시 정품만 요청하실 경우 접수 시 말씀해 주시면 그에 맞춰 안내드리며, 사용 부품은 수리 명세서에 투명하게 기재합니다.",
  },
];

export const repairCases = [
  {
    id: "case-1",
    tag: "침수 복구",
    title: "커피 침수 로직보드 복구",
    device: "MacBook Pro 14 M1 Pro",
    summary:
      "음료 침수로 부식된 회로를 초음파 세척하고 재코팅하여 정상 부팅과 데이터 보존까지 완료했습니다.",
    beforeSrc:
      "https://readdy.ai/api/search-image?query=Severely%20water%20damaged%20laptop%20logic%20board%20with%20green%20corrosion%20and%20white%20oxidation%20around%20electronic%20components%2C%20dramatic%20dark%20studio%20background%20with%20cool%20blue%20light%2C%20macro%20photography%20of%20a%20damaged%20circuit%20board&width=1200&height=900&seq=case1-before-mfx&orientation=landscape",
    afterSrc:
      "https://readdy.ai/api/search-image?query=Perfectly%20restored%20laptop%20logic%20board%20with%20clean%20shiny%20circuit%20board%20surface%20and%20newly%20soldered%20components%2C%20dramatic%20dark%20studio%20background%20with%20cool%20blue%20light%2C%20macro%20photography%20of%20a%20pristine%20circuit%20board&width=1200&height=900&seq=case1-after-mfx&orientation=landscape",
  },
  {
    id: "case-2",
    tag: "전원 수리",
    title: "전원부 소손 로직보드 복구",
    device: "MacBook Air M1",
    summary:
      "충전 단자 주변 전원부가 탄 상태에서 손상 부품을 교체하고 회로를 복구해 충전과 부팅을 정상화했습니다.",
    beforeSrc:
      "https://readdy.ai/api/search-image?query=Burnt%20laptop%20motherboard%20with%20black%20scorch%20marks%20and%20damaged%20components%20near%20the%20power%20connector%2C%20dark%20moody%20studio%20background%20with%20blue%20rim%20light%2C%20close%20up%20electronics%20photography&width=1200&height=900&seq=case2-before-mfx&orientation=landscape",
    afterSrc:
      "https://readdy.ai/api/search-image?query=Clean%20repaired%20laptop%20motherboard%20with%20freshly%20replaced%20power%20section%20and%20neat%20silver%20solder%20joints%2C%20dark%20moody%20studio%20background%20with%20blue%20rim%20light%2C%20close%20up%20electronics%20photography&width=1200&height=900&seq=case2-after-mfx&orientation=landscape",
  },
  {
    id: "case-3",
    tag: "디스플레이",
    title: "액정 파손 디스플레이 교체",
    device: "MacBook Pro 13 2019",
    summary:
      "충격으로 깨진 패널을 정품급 패널로 교체하고 색 재현과 밝기를 검수하여 출고했습니다.",
    beforeSrc:
      "https://readdy.ai/api/search-image?query=Cracked%20laptop%20display%20screen%20with%20spider%20web%20shattered%20glass%20and%20black%20dead%20pixel%20patches%20glowing%20dimly%2C%20dark%20studio%20background%2C%20product%20photography&width=1200&height=900&seq=case3-before-mfx&orientation=landscape",
    afterSrc:
      "https://readdy.ai/api/search-image?query=Flawless%20brand%20new%20laptop%20display%20screen%20showing%20a%20clean%20bright%20vivid%20colorful%20image%20with%20no%20damage%2C%20dark%20studio%20background%2C%20product%20photography&width=1200&height=900&seq=case3-after-mfx&orientation=landscape",
  },
];